import LaboratoryResponse from "../../../../api/models/LaboratoryResponse";
import CSCLaboratory from "../CSCLaboratory";

const getLaboratoryIds = (laboratories: LaboratoryResponse[], data: CSCLaboratory[]) => {
  const labIds = laboratories.reduce((acc: number[], el: LaboratoryResponse) => {
    if (data.includes(el.key)) {
      return acc.concat(el.id);
    }
    return acc;
  }, []);
  return labIds;
};

export default getLaboratoryIds;
